/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './SettingsContent.scss';

const SettingsZendeskRequest = (props) => {
  const { bot, updateGlpiSettings, user } = props;
  const { i18n } = useTranslation();

  const [GlpiSettings, setGlpiSettings] = useState({
    apiUrl: '',
    appToken: '',
    userToken: '',
  });

  useEffect(() => {
    if (bot && bot.settings && bot.settings.glpiSettings) {
      setGlpiSettings(bot.settings.glpiSettings);
    }
  }, [bot]);

  const changeSettings = (name, value) => {
    const updatedSettings = { ...GlpiSettings, [name]: value };
    setGlpiSettings(updatedSettings);
  };

  const updateBot = () => {
    if (bot) {
      const data = GlpiSettings;
      updateGlpiSettings(bot._id, data);
    }
  };

  return (
    <div className="human-type-container">
      <div className="human-type-container" style={{ height: '70%' }}>
        <div>
          <div className="title">
            {i18n.t('Configurar Integrações ')}
            <strong>{i18n.t('GLPi')}</strong>
          </div>
          <div className="subtitle mt-2">
            {i18n.t('Insira os campos abaixo disponíveis em sua conta GLPi')}
          </div>
        </div>
        <div className="form-group mt-3">
          <label>{i18n.t('API URL')}:</label>
          <input
            disabled={!!(user && user.selectedCompany.claim.name === 'Viewer')}
            name="apiUrl"
            className="form-control"
            placeholder=".glpi-network.cloud/apirest.php"
            value={GlpiSettings.apiUrl || ''}
            onChange={(e) => changeSettings(e.target.name, e.target.value)}
          />
        </div>
        <div className="form-group mt-2">
          <label>{i18n.t('App Token')}:</label>
          <input
            disabled={!!(user && user.selectedCompany.claim.name === 'Viewer')}
            name="appToken"
            className="form-control"
            placeholder="PCGasdy6sLzkaMj0j6qw8rFKY"
            value={GlpiSettings.appToken || ''}
            onChange={(e) => changeSettings(e.target.name, e.target.value)}
          />
        </div>
        <div className="form-group mt-2">
          <label>{i18n.t('User Token')}:</label>
          <input
            disabled={!!(user && user.selectedCompany.claim.name === 'Viewer')}
            name="userToken"
            className="form-control"
            placeholder="PCGasdy6sLzkaMj0j6qw8rFKY"
            value={GlpiSettings.userToken || ''}
            onChange={(e) => changeSettings(e.target.name, e.target.value)}
          />
        </div>
      </div>
      <div className="form-group mt-3">
        <button
          disabled={!!(user && user.selectedCompany.claim.name === 'Viewer')}
          className="btn btn-primary"
          onClick={updateBot}
        >
          {i18n.t('salvar')}
        </button>
      </div>
    </div>
  );
};

export default SettingsZendeskRequest;
